module.exports = __webpack_public_path__ + "static/androidBannerCTOGramm-5f768cb63f2047e4c7a280cc3b2b907d.png";